import React, { Component } from "react";
import { WithRouterProps, withRouter } from "../components/shared/WithRouter";
import { ITrackerConfigModel, TrackersEnum } from "../models/TrackerModel";
import { trackerConfigurations } from "../config/TrackersConfig";
import GenericTracker from "../components/tracker/GenericTracker";
import {
  ILeadTrackerConfigModel,
  ITrackerResponseModel,
} from "nfg-tracker-module";
import { getAmountValue, getPercetSymbol } from "../utils/GeneralUtils";
import Service from "../services";
import { catchError } from "../utils/Utils";
import { RoutesEnum } from "../utils/RoutesUtil";
import { BankUserContext } from "../bankUserContext";
import { toast } from "react-toastify";
import { transformDateWithoutTime } from "../utils/dateUtil";
import FinSpinner from "../commonfields/FinSpinner";
import { setFilters } from "../components/Filters/FiltersHelper";
import { actionAuthorization } from "../utils/RolesUtil";
import { withContext } from "../components/Authentication/RoleAuthorizationClassComponent";
import { faL } from "@fortawesome/free-solid-svg-icons";
import DynamicProductIcon from "../commonfields/DynamicProductIcon";
import EllipsisTooltip from "../utils/EllipsisTooltip";


interface ITrackerPageState {
  baseConfig: ITrackerConfigModel | undefined;
  trackerConfig: ILeadTrackerConfigModel[];
  trackerData: ITrackerResponseModel[];
  trackerListConfig: any;
  resetTracker: boolean;
  loader: boolean;
}

class TrackerPage extends Component<
  WithRouterProps<unknown>,
  ITrackerPageState
> {
  service: Service;
  static contextType = BankUserContext;
  context: React.ContextType<typeof BankUserContext> | undefined;
  constructor(props: WithRouterProps<unknown>) {
    super(props);

    this.state = {
      baseConfig: undefined,
      trackerConfig: [],
      trackerData: [],
      trackerListConfig: [],
      resetTracker: false,
      loader: false,
    };
    this.service = new Service();
  }

  setResetTracker = (value: boolean) => this.setState({ resetTracker: value });

  getConfig = async (getTrackerType: string) => {
    let selectedProductSession = null;
    const selectedProductSessionRaw = sessionStorage.getItem("selectedProduct");
    if (selectedProductSessionRaw) {
      selectedProductSession = JSON.parse(selectedProductSessionRaw);
    }
    let payload: any = {
      orgId: this.context?.bankuserDetails?.organization.orgId,
      isJsonReturnObject: true,
      screen: "ProspectsTR",
      trackerMasterId: "dfa6cf96-375f-11ee-be56-0242ac120002",
      sections: "ProspectingMetaData",
    };
    if (getTrackerType === TrackersEnum.PROSPECTING) {
      payload = {
        ...payload,
        trackerMasterId: "dfa6cf96-375f-11ee-be56-0242ac120002",
        sections: "ProspectingMetaData",
      };
    } else if (getTrackerType === TrackersEnum.APPLICATIONS) {
      payload = {
        ...payload,
        trackerMasterId: "829ba560-3f89-11ee-be56-0242ac120002",
        sections: "getMetaDataOnOrgProdId",
        orgLevelProductId: selectedProductSession?.orgLevelProductId || this.props.params.orgProductId,
      };
    } else if (getTrackerType === TrackersEnum.OPPORTUNITIES) {
      payload = {
        ...payload,
        trackerMasterId: "7008b500-4182-11ee-be56-0242ac120002",
        sections: "getMetaDataOnOrgProdId",
        orgLevelProductId: selectedProductSession?.orgLevelProductId || this.props.params.orgProductId,
      };
    } else if (getTrackerType === TrackersEnum.UNDERWRITING) {
      payload = {
        ...payload,
        trackerMasterId: "988ba560-3f89-11ee-be56-0242ac140056",
        sections: "getMetaDataOnOrgProdId",
        orgLevelProductId: selectedProductSession?.orgLevelProductId || this.props.params.orgProductId,
      };
    } else if (getTrackerType === TrackersEnum.RELATIONSHIPS) {
      payload = {
        ...payload,
        trackerMasterId: "a3bf2145-4a61-4c30-afb1-d9dad57a28dc",
        sections: "ProspectingMetaData",
      };
    }
    return this.service.getLeadsData(payload);
  };

  getTrackerListConfig = async (getTrackerType: string) => {
    let trackerMasterId = "";
    if (getTrackerType === TrackersEnum.PROSPECTING) {
      trackerMasterId = "dfa6cf96-375f-11ee-be56-0242ac120002";
    } else if (getTrackerType === TrackersEnum.APPLICATIONS) {
      trackerMasterId = "829ba560-3f89-11ee-be56-0242ac120002";
    } else if (getTrackerType === TrackersEnum.OPPORTUNITIES) {
      trackerMasterId = "7008b500-4182-11ee-be56-0242ac120002";
    } else if (getTrackerType === TrackersEnum.UNDERWRITING) {
      trackerMasterId = "988ba560-3f89-11ee-be56-0242ac140056";
    } else if (getTrackerType === TrackersEnum.RELATIONSHIPS) {
      trackerMasterId = "a3bf2145-4a61-4c30-afb1-d9dad57a28dc";
    } else {
      trackerMasterId = "dfa6cf96-375f-11ee-be56-0242ac120002";
    }

    const payload = {
      isJsonReturnObject: false,
      jsonReturnObject: false,
      orgId: this.context?.bankuserDetails?.organization.orgId,
      screen: "ProspectListView",
      sections: "getProspectListView",
      trackerMasterId,
    };
    return this.service.getLeadsData(payload);
  };

  modifyFiltersData = (filtersDataObj: any, payload: any) => {
    const keys = Object?.keys(filtersDataObj);
    if (keys?.length > 0) {
      keys?.forEach((key: any) => {
        if (filtersDataObj[key] != null && filtersDataObj[key]?.length > 0) {
          payload[key] = filtersDataObj[key];
        }
      });
    }
  };

  getTrackerData = async (getTrackerType: string, extraFields?: any) => {
    this.setState({ loader: true });
    let selectedProductSession = null;
    const selectedProductSessionRaw = sessionStorage.getItem("selectedProduct");
    if (selectedProductSessionRaw) {
      selectedProductSession = JSON.parse(selectedProductSessionRaw);
    }
    let payload: any = {};
    extraFields && this.modifyFiltersData(extraFields, payload);

    if (getTrackerType === TrackersEnum.PROSPECTING) {
      payload = {
        ...payload,
        orgId: this.context?.bankuserDetails?.organization.orgId,
        screen: "ProspectsTR",
        sections: "ClientsByOrg",
        isJsonReturnObject: false,
        isArchive: payload.archive ? true : false,
      };
    } else if (getTrackerType === TrackersEnum.APPLICATIONS) {
      payload = {
        ...payload,
        orgId: this.context?.bankuserDetails?.organization.orgId,
        screen: "ProspectTracker",
        sections: "GetTrackers",
        trackerMasterId: "829ba560-3f89-11ee-be56-0242ac120002",
        orgLevelProductId: selectedProductSession?.orgLevelProductId || this.props.params.orgProductId,
        isJsonReturnObject: false,
        isArchive: payload.archive ? true : false,
      };
    } else if (getTrackerType === TrackersEnum.OPPORTUNITIES) {
      payload = {
        ...payload,
        orgId: this.context?.bankuserDetails?.organization.orgId,
        screen: "ProspectTracker",
        sections: "GetTrackers",
        trackerMasterId: "7008b500-4182-11ee-be56-0242ac120002",
        orgLevelProductId: selectedProductSession?.orgLevelProductId || this.props.params.orgProductId,
        isJsonReturnObject: false,
        isArchive: payload.archive ? true : false,
      };
    } else if (getTrackerType === TrackersEnum.UNDERWRITING) {
      payload = {
        ...payload,
        orgId: this.context?.bankuserDetails?.organization.orgId,
        screen: "ProspectTracker",
        sections: "getUnderwriterTracker",
        trackerMasterId: "988ba560-3f89-11ee-be56-0242ac140056",
        orgLevelProductId: selectedProductSession?.orgLevelProductId || this.props.params.orgProductId,
        isJsonReturnObject: false,
        isArchive: payload.archive ? true : false,
      };
    } else if (getTrackerType === TrackersEnum.RELATIONSHIPS) {
      payload = {
        ...payload,
        screen: "RelationshipTracker",
        sections: "GetRelationshipTracker",
        trackerMasterId: "a3bf2145-4a61-4c30-afb1-d9dad57a28dc",
        orgId: this.context?.bankuserDetails?.organization.orgId,
        isJsonReturnObject: false,
      };
    }

    if (Object.keys(payload)?.length > 0) {
      return this.service.getLeadsData(payload).then((res: any) => {
        this.setState({ loader: false });
        return res;
      })
    } else return;
  };
  TooltipWrapper = (content: string = "") => {
    return (
      <div className="lable tooltip-container">
        <span className="title">
          {content.length > 12 ? content.substring(0, 12) + "..." : content}
        </span>
      </div>
    );
  };

  modifyData = (data: any) => {
    if (data && data?.length > 0) {
      return data?.map((each: any, index: number) => {
        let assigneeList = [];
        if (each?.assigneeList) {
          assigneeList = JSON.parse(each?.assigneeList);
        }
        let operatingStates = [];
        if (each?.operatingStates) {
          operatingStates = JSON.parse(each?.operatingStates);
        }
        let productList = [];
        if (each?.productList) {
          productList = JSON.parse(each?.productList);

        }


        return {
          ...each,
          uuid: `${each?.clientProductsId || each?.clientId}-${index}`, // unique id for key and menu options
          estimatedValue: this.TooltipWrapper(getAmountValue(each?.estimatedValue)),
          // <EllipsisTooltip text={ getAmountValue(each?.estimatedValue)}maxLine={12}></EllipsisTooltip>
          percentageToSale: getPercetSymbol(each?.percentageToSale),
          dynamicProductIcon: each?.productId != null ? <DynamicProductIcon productName={each?.productName} /> : null,
          expectedCloseDate:
            transformDateWithoutTime(each?.expectedCloseDate) || null,
          // convert assignee list object [] to string []
          ...(assigneeList && assigneeList?.length > 0
            ? {
              assigneeList: assigneeList?.map(
                (each: { name: string }) => each?.name || ""
              ),
            }
            : {}),
          // convert operatingStates object [] to string []
          ...(operatingStates && operatingStates?.length > 0
            ? {
              operatingStates: operatingStates?.map(
                (each: { account: string }) => each?.account || ""
              ),
            }
            : {}),
          productList: productList || [],
          relationshipProductIcon: productList.map((product: any) => product?.product_id ? <DynamicProductIcon productId={product?.product_id} /> : null),

        };

      });

    } else return [];
  };

  getModifiedListData = (data: any) => {
    const listViewRaw = data?.[0]?.list_view;
    if (listViewRaw) {
      const listViewModified = listViewRaw?.replace(/\s/, "");
      if (listViewModified) {
        return { listView: JSON.parse(listViewModified) }; // Todo: set parse data
      } else return { listView: [] };
    } else return { listView: [] };
  };

  // extraFields - contains search, filter and sort directions
  setTrackerData = async (extraFields: any) => {
    const getTrackerTypeList = this?.props?.location?.pathname?.split("/");
    const getTrackerType = getTrackerTypeList?.[2] || TrackersEnum.DEFAULT;
    let trackerDataRaw: any = [];

    try {
      trackerDataRaw = await this.getTrackerData(getTrackerType, extraFields);
    } catch (err) {
      catchError(err, true);
    }

    if (getTrackerType) {
      this.setState({
        trackerData: this.modifyData(trackerDataRaw?.data),
      });
    }
  };

  changeConfig = async (pathname: string, loadData = true) => {
    this.setState({ loader: true, baseConfig: undefined, trackerData: [], trackerConfig: [] });
    const getTrackerTypeList = pathname?.split("/");
    const getTrackerType = getTrackerTypeList?.[2] || TrackersEnum.DEFAULT;
    let trackerConfigRaw: any = [];
    let trackerDataRaw: any = [];
    let trackerListConfigRaw: any = [];

    try {
      trackerConfigRaw = await this.getConfig(getTrackerType);
      trackerListConfigRaw = await this.getTrackerListConfig(getTrackerType);
      if (loadData) trackerDataRaw = await this.getTrackerData(getTrackerType);
    } catch (err) {
      catchError(err, true);
      this.setState({ loader: false });
    }

    if (getTrackerType) {
      let baseConfigTracker = trackerConfigurations?.find(
        (each) => each?.type === getTrackerType
      );
      if (baseConfigTracker) {
        baseConfigTracker = {
          ...baseConfigTracker,
          createLead: withContext(
            this.context,
            getTrackerType,
            actionAuthorization.createLead
          ),
        };
      }
      this.setState({
        baseConfig: baseConfigTracker,
        trackerConfig: trackerConfigRaw?.data || [],
        trackerListConfig: this.getModifiedListData(trackerListConfigRaw?.data),
        loader: false,
      });

      if (loadData) {
        this.setState({
          trackerData: this.modifyData(trackerDataRaw?.data),
        });
      }
    }
  };

  cardHandler = (data: any) => {
    const getTrackerTypeList = this.props?.location?.pathname?.split("/");
    const getTrackerType = getTrackerTypeList?.[2] || TrackersEnum.DEFAULT;
    let url = `/${RoutesEnum.TRACKER_DETAILSPAGE}/${getTrackerType}/${data?.clientId}`;
    if (data?.clientProductsId) {
      url = url + `/${data?.clientProductsId}`;
    }
    this.props?.navigate(url);
  };

  componentDidMount(): void {
    if (this.props?.location?.pathname) {
      this.changeConfig(this.props?.location?.pathname);
    }
  }

  componentDidUpdate(prevProps: WithRouterProps<unknown>): void {
    if (prevProps?.location?.pathname !== this.props?.location?.pathname) {
      this.changeConfig(this.props?.location?.pathname, false);
      this.setState({
        resetTracker: true,
      });
    }
  }

  render() {
    const {
      baseConfig,
      trackerConfig,
      trackerData,
      trackerListConfig,
      loader,
    } = this.state;
    return (
      <>
        {loader ? <FinSpinner /> : <></>}

        {baseConfig &&
          (
            <GenericTracker
              baseConfig={baseConfig}
              trackerConfig={trackerConfig}
              trackerData={trackerData}
              trackerListConfig={trackerListConfig}
              cardHandler={this.cardHandler}
              resetTracker={this.state.resetTracker}
              setResetTracker={this.setResetTracker}
              setTrackerData={this.setTrackerData}
            />
          )}
      </>
    );
  }
}

export default withRouter<WithRouterProps<unknown>>(TrackerPage);
